import { render } from "./App.vue?vue&type=template&id=70a30210"
const script = {}

import "./App.vue?vue&type=style&index=0&id=70a30210&lang=css"

import exportComponent from "E:\\REPOSITORIOS\\appproductora\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__